import { getAll } from '@bigyouth/base'
import axios from 'axios'
import isMobile from 'ismobilejs'

export default {
  name: 'actions',

  ui: {
    love: '[js-actions-love]',
    shareToggle: '[js-actions-share-toggle]',
    share: '[js-actions-share]',
    download: '[js-actions-dl]',
  },

  events: [
    {
      on: 'click',
      target: 'love',
      handle ({ target }) {
        if (this.props.isConnected) {
          axios.post(this.props.loveUrl)
            .then(response => {
              getAll('[js-actions-love]').forEach((btn) => {
                if (btn.classList.contains('is-active')) {
                  btn.classList.remove('is-active')
                } else {
                  btn.classList.toggle('is-animated')
                }
              })
            })
            .catch(e => {
              console.log(e)
            })
        } else {
          target.classList.add('has-tooltip')

          setTimeout(() => {
            target.classList.remove('has-tooltip')
          }, 2000)
        }
      },
    },
    {
      on: 'click',
      target: 'shareToggle',
      handle () {
        if (navigator.share && isMobile().any) {
          navigator.share({
            title: this.ui.shareToggle.dataset.title,
            text: this.ui.shareToggle.dataset.text,
            url: document.location.href,
          })
            .then(() => console.log('Successful share'))
            .catch((error) => console.log('Error sharing', error))
        } else {
          this.ui.share.classList.toggle('is-visible')
        }
      },
    },
  ],

  componentDidMount () {
    document.addEventListener('click', (e) => {
      if (
        e.target !== this.ui.shareToggle &&
        e.target.closest('[js-actions-share]') === null &&
        this.ui.share.classList.contains('is-visible')
      ) {
        this.ui.share.classList.remove('is-visible')
      }
    })
  },
}
